import noAuthHttpClient from 'hub-http/clients/noAuthApiClient';
import { getPortalId } from '../../../utils/getPortalId';
import { setStorageJsonValue, SUPERSTORE_NAMESPACES, SUPERSTORE_STORAGE_ITEMS, SUPERSTORE_STORAGE_KEYS } from '../../../utils/superStoreUtils';

/**
 * Hit the presence ping endpoint with a token.
 * The token allows a cheaper ping call as authentication can be bypassed
 */
export const makePresencePing = async (token, userId) => {
  try {
    const portalId = getPortalId();
    await noAuthHttpClient.put(`/presence/v1/presence/portal/${portalId}/user/${userId}`, {
      query: {
        portalId
      },
      data: {
        token
      }
    });
  } catch (e) {
    await setStorageJsonValue({
      namespace: SUPERSTORE_NAMESPACES.NOTIFICATION,
      storageKey: SUPERSTORE_STORAGE_KEYS.BROWSER,
      storageItem: SUPERSTORE_STORAGE_ITEMS.PRESENCE_PING_TOKEN,
      value: undefined
    });
  }
};